import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { InertiaPlugin } from 'gsap/InertiaPlugin';
import rechargepayment from '../assets/Images/recharge-payments.png';
import referearn from '../assets/Images/refer-earn.jpg';
import giftvouchars from "../assets/Images/gift-vouchers.jpg"
import booking from '../assets/Images/booking.png';

gsap.registerPlugin(InertiaPlugin);

export default function About() {
  let oldX = 0, oldY = 0, deltaX = 0, deltaY = 0;

  // Bounce animation on in-view
  const sectionRef = useRef();
  const [aboutInView, setAboutInView] = useState(false);
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setAboutInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const root = sectionRef.current;
    if (!root) return;

    const handleMouseMove = (e) => {
      deltaX = e.clientX - oldX;
      deltaY = e.clientY - oldY;
      oldX = e.clientX;
      oldY = e.clientY;
    };

    const mediaElements = root.querySelectorAll('.media');

    mediaElements.forEach(el => {
      const image = el.querySelector('img');

      el.addEventListener('mouseenter', () => {
        const tl = gsap.timeline({
          onComplete: () => tl.kill()
        });

        tl.timeScale(1.2);

        tl.to(image, {
          inertia: {
            x: {
              velocity: deltaX * 30,
              end: 0
            },
            y: {
              velocity: deltaY * 30,
              end: 0
            }
          }
        });

        tl.fromTo(image, {
          rotate: 0
        }, {
          duration: 0.4,
          rotate: (Math.random() - 0.5) * 30,
          yoyo: true,
          repeat: 1,
          ease: 'power1.inOut'
        }, '<');
      });
    });

    root.addEventListener('mousemove', handleMouseMove);

    return () => {
      root.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 font-sans" ref={sectionRef}>
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-12 text-center">About Me</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
        <div className="w-full flex justify-center">
          <div className="grid grid-cols-2 gap-2 sm:gap-4 w-full max-w-xs sm:max-w-sm md:max-w-md aspect-square rounded-xl overflow-hidden bg-black p-2 sm:p-4">
            <div className={`media w-full aspect-square flex items-center justify-center pt-8 sm:pt-12 transition-all ${aboutInView ? 'animate-bounce' : ''}`} style={{animationDelay: aboutInView ? '0ms' : '0ms'}}>
              <img src={booking} alt="booking" className="w-full h-full object-contain" />
            </div>
            <div className={`media w-full aspect-square flex items-center justify-center transition-all ${aboutInView ? 'animate-bounce' : ''}`} style={{animationDelay: aboutInView ? '150ms' : '0ms'}}>
              <img src={giftvouchars} alt="Vouchars" className="w-full h-full object-contain rounded-xl" />
            </div>
            <div className={`media w-full aspect-square flex items-center justify-center transition-all ${aboutInView ? 'animate-bounce' : ''}`} style={{animationDelay: aboutInView ? '300ms' : '0ms'}}>
              <img src={referearn} alt="Refer & earn" className="w-full h-full object-contain rounded-xl" />
            </div>
            <div className={`media w-full aspect-square flex items-center justify-center p-2 sm:p-4 transition-all ${aboutInView ? 'animate-bounce' : ''}`} style={{animationDelay: aboutInView ? '450ms' : '0ms'}}>
              <img src={rechargepayment} alt="Recharge & Payments" className="w-full h-full object-contain rounded-full" />
            </div>
          </div>
        </div>
        <div className="w-full">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 sm:mb-4">Filmy Quiz App</h3>
          <p className="text-gray-400 mb-3 sm:mb-6 text-base sm:text-lg">
            Filmy Quiz App is a Quiz mobile app which conducts online quiz based on malayalam movies. Here by attending Quiz and earn 1000 points, One Winner for Everyday will get a gift worth ₹5000 , Sponsored by Regal home Appliances, Koppam. Any Product worth ₹5000 could be claimed by the Winner.
          </p>
          <p className="text-gray-400 mb-3 sm:mb-6 text-base sm:text-lg">
            In addition to that selected movie tickets could be claimed with the earned points(Movie tickets are Subject to availability). There is no charge involved at any point to attend the Quiz or claim the rewards.
          </p>
          <p className="text-gray-400 mb-3 sm:mb-6 text-base sm:text-lg font-semibold text-purple-400">
            Download the Filmy Quiz App now. Happy Quizing!
          </p>
          
          <div className="mt-6 mb-6">
            <a
              href="https://play.google.com/store/apps/details?id=com.perutions.cqz&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-zinc-950 hover:bg-zinc-900 border border-zinc-800 text-white px-5 py-2.5 rounded-lg transition-colors shadow-lg"
            >
              <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,5.27V18.73L16.5,12L3,5.27M17.87,11.33L19.44,12.11C20.19,12.49 20.19,13.5 19.44,13.88L17.87,14.67L15.93,13.7L17.87,11.33M3,3.41C3.65,2.94 4.58,2.95 5.25,3.41L15.65,11.21L13.84,13.43L3,3.41M3,20.59L13.84,10.57L15.65,12.79L5.25,20.59C4.58,21.05 3.65,21.06 3,20.59Z" />
              </svg>
              <div className="text-left">
                <p className="text-[10px] uppercase font-bold tracking-wider text-gray-400 leading-none">Get it on</p>
                <p className="text-base font-semibold font-sans leading-tight mt-0.5">Google Play</p>
              </div>
            </a>
          </div>

          <div className="flex flex-wrap gap-2 sm:gap-3 mt-4">
            <span className="px-3 py-1 sm:px-4 sm:py-2 bg-purple-100 text-purple-800 rounded-full text-xs sm:text-sm">Movies</span>
            <span className="px-3 py-1 sm:px-4 sm:py-2 bg-purple-100 text-purple-800 rounded-full text-xs sm:text-sm">Quiz</span>
            <span className="px-3 py-1 sm:px-4 sm:py-2 bg-purple-100 text-purple-800 rounded-full text-xs sm:text-sm">Rewards</span>
            <span className="px-3 py-1 sm:px-4 sm:py-2 bg-purple-100 text-purple-800 rounded-full text-xs sm:text-sm">Daily Winner</span>
            <span className="px-3 py-1 sm:px-4 sm:py-2 bg-purple-100 text-purple-800 rounded-full text-xs sm:text-sm">Malayalam Cinema</span>
          </div>
        </div>
      </div>
    </div>
  );
}
  
